import { useEffect, useState } from 'react';

import { motion, AnimatePresence } from 'framer-motion';

import { Users } from 'lucide-react';

import { visitorService } from '../services/visitorService';



export function VisitorCounter() {

  const [visitorCount, setVisitorCount] = useState<number | null>(null);

  const [isVisible, setIsVisible] = useState(true);



  useEffect(() => {

    const fetchCount = async () => {

      const count = await visitorService.incrementVisitorCount();

      setVisitorCount(count);

    };



    fetchCount();



    // Hide counter after 5 seconds

    const timer = setTimeout(() => {

      setIsVisible(false);

    }, 5000);



    return () => clearTimeout(timer);

  }, []);



  return (

    <AnimatePresence>

      {isVisible && visitorCount !== null && (

        <motion.div

          initial={{ opacity: 0, y: 20 }}

          animate={{ opacity: 1, y: 0 }}

          exit={{ opacity: 0, y: 20 }}

          className="fixed bottom-4 right-4 bg-white/10 backdrop-blur-md rounded-full px-4 py-2 text-white flex items-center space-x-2 shadow-lg z-50"

        >

          <Users className="w-4 h-4" />

          <span className="font-mono">

            {visitorCount.toLocaleString()} visitor{visitorCount !== 1 ? 's' : ''}

          </span>

        </motion.div>

      )}

    </AnimatePresence>

  );

} 
